if (!customElements.get('product-card-quick-add')) {
  customElements.define(
    'product-card-quick-add',
    class ProductCardQuickAdd extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantInput = this.form.querySelector('[name="id"]');
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.submitLabel = this.submitButton.querySelector('.product-card-quick-add__submit-label');
        this.spinner = this.submitButton.querySelector('.loading-overlay__spinner');
        this.errorEl = this.form.querySelector('.product-card-quick-add__error');
        this.optionInputs = this.form.querySelectorAll('[data-option-index]');
        this.cartNotification = document.querySelector('cart-notification');
        this.triggerButton = this.querySelector('.product-card-quick-add__trigger');
        this.panel = this.querySelector('.product-card-quick-add__panel');
        this.cardWrapper = this.closest('.card-wrapper');
        this.isGated = this.dataset.gated === 'true' || this.classList.contains('product-card-quick-add--gated');

        const jsonEl = this.form.querySelector('script[type="application/json"]');
        this.variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];

        this.onTriggerClick = this.onTriggerClick.bind(this);
        this.onCardLeave = this.onCardLeave.bind(this);

        this.addEventListener('click', (event) => event.stopPropagation());

        if (this.triggerButton && this.panel) {
          this.triggerButton.addEventListener('click', this.onTriggerClick);
        }

        if (this.isGated && this.cardWrapper) {
          this.cardWrapper.addEventListener('mouseleave', this.onCardLeave);
        }

        this.optionInputs.forEach((input) => {
          if (input.tagName === 'SELECT') {
            input.addEventListener('change', () => {
              this.updateVariant();
              if (input.hasAttribute('data-card-color-option')) {
                this.previewSelectedColor(input);
              }
            });
          }
        });

        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        this.updateVariant();
        this.optionInputs.forEach((input) => {
          if (input.tagName === 'SELECT' && input.hasAttribute('data-card-color-option') && input.value) {
            this.previewSelectedColor(input);
          }
        });
      }

      disconnectedCallback() {
        if (this.triggerButton) {
          this.triggerButton.removeEventListener('click', this.onTriggerClick);
        }
        if (this.cardWrapper) {
          this.cardWrapper.removeEventListener('mouseleave', this.onCardLeave);
        }
      }

      onTriggerClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.openPanel();
      }

      onCardLeave() {
        if (!this.isGated) return;
        this.resetPanel();
      }

      openPanel() {
        if (!this.triggerButton || !this.panel) return;
        if (this.classList.contains('is-open')) return;

        this.classList.add('is-open');
        this.triggerButton.setAttribute('aria-expanded', 'true');
        this.triggerButton.hidden = true;
        this.panel.hidden = false;
      }

      resetPanel() {
        if (!this.triggerButton || !this.panel) return;

        this.classList.remove('is-open');
        this.triggerButton.setAttribute('aria-expanded', 'false');
        this.triggerButton.hidden = false;
        this.panel.hidden = true;
        this.clearError();
      }

      previewSelectedColor(select) {
        if (!select || !select.value) return;

        const option = select.selectedOptions && select.selectedOptions[0];
        if (!option || !option.getAttribute('data-media-src')) return;

        const card = this.closest('.card-wrapper');
        if (!card) return;

        if (window.CarlProductCardColors && typeof window.CarlProductCardColors.applyColorPreview === 'function') {
          window.CarlProductCardColors.applyColorPreview(card, option);
          return;
        }

        const url = option.getAttribute('data-variant-url');
        if (url) {
          card.querySelectorAll('a.full-unstyled-link, a.card__media-link').forEach((link) => {
            link.setAttribute('href', url);
          });
        }

        const media = card.querySelector('.card .media');
        const primary = media && media.querySelector('[data-card-primary-media]');
        if (!primary || primary.tagName !== 'IMG') return;

        const src = option.getAttribute('data-media-src');
        const srcset = option.getAttribute('data-media-srcset');
        const alt = option.getAttribute('data-media-alt');
        if (src) primary.setAttribute('src', src);
        if (srcset) primary.setAttribute('srcset', srcset);
        if (alt) primary.setAttribute('alt', alt);
      }

      getSelectedOptions() {
        const values = [];
        this.optionInputs.forEach((input) => {
          const index = Number(input.dataset.optionIndex);
          values[index] = input.value;
        });
        return values;
      }

      findVariant(options) {
        if (!options.length) return this.variants[0] || null;
        if (options.some((value) => !value)) return null;

        return (
          this.variants.find((variant) =>
            variant.options.every((option, index) => option === options[index])
          ) || null
        );
      }

      updateVariant() {
        const options = this.getSelectedOptions();
        const variant = this.findVariant(options);
        const addLabel = this.dataset.addLabel || window.variantStrings?.addToCart || 'Add to cart';
        const soldOutLabel = window.variantStrings?.soldOut || 'Sold out';
        const unavailableLabel = window.variantStrings?.unavailable || 'Unavailable';

        if (!variant) {
          this.variantInput.value = '';
          this.variantInput.disabled = true;
          this.submitButton.disabled = true;
          this.submitLabel.textContent = options.some((value) => !value) ? addLabel : unavailableLabel;
          return;
        }

        this.variantInput.value = variant.id;
        this.variantInput.disabled = !variant.available;
        this.submitButton.disabled = !variant.available;
        this.submitLabel.textContent = variant.available ? addLabel : soldOutLabel;
        this.clearError();
      }

      onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.submitButton.disabled || this.submitButton.classList.contains('loading')) return;
        if (!this.variantInput.value) {
          this.showError('Please select options');
          return;
        }

        this.clearError();
        this.submitButton.classList.add('loading');
        this.submitButton.setAttribute('aria-disabled', 'true');
        if (this.spinner) this.spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cartNotification) {
          this.cartNotification.setActiveElement(document.activeElement);
          formData.append(
            'sections',
            this.cartNotification.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || window.cartStrings?.error || 'Unable to add to cart');
              return;
            }

            if (this.cartNotification) {
              this.cartNotification.renderContents(response);
            }
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(() => {
            this.showError(window.cartStrings?.error || 'Unable to add to cart');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (this.spinner) this.spinner.classList.add('hidden');
          });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.hidden = false;
        this.errorEl.textContent = message;
      }

      clearError() {
        if (!this.errorEl) return;
        this.errorEl.hidden = true;
        this.errorEl.textContent = '';
      }
    }
  );
}
